module.exports = __webpack_public_path__ + "images/4.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/img/message_outbound/slider/4.jpg
 ** module id = 648
 ** module chunks = 0
 **/